/**
 * CLEARO sticky "Add to cart" bar — <clearo-sticky-atc>
 * Shows on small screens once the main Add to cart button has scrolled above
 * the viewport; hides near the footer. Mirrors price, selected options and
 * sold-out state from the main product form, and clicks its real button.
 * Markup & styles: sections/clearo-sticky-atc.liquid.
 */
(() => {
  if (customElements.get('clearo-sticky-atc')) return;

  const small = window.matchMedia('(max-width: 989px)');

  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.mainButton = document.querySelector('.product-form__submit[name="add"]');
      this.mainForm = this.mainButton && this.mainButton.closest('form');
      this.info = document.querySelector('.product__info-container');
      if (!this.mainButton || !this.info) return;

      this.btn = this.querySelector('[data-button]');
      this.label = this.querySelector('[data-label]');
      this.priceEl = this.querySelector('[data-price]');
      this.variantEl = this.querySelector('[data-variant]');
      this.aboveButton = false;
      this.footerVisible = false;

      this.hidden = false;
      document.body.classList.add('clr-has-satc');

      // Visibility: main button scrolled out above, and footer not on screen
      this.buttonObserver = new IntersectionObserver(([entry]) => {
        this.aboveButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.updateVisibility();
      });
      this.buttonObserver.observe(this.mainButton);

      const footer = document.querySelector('.clr-foot, footer');
      if (footer) {
        this.footerObserver = new IntersectionObserver(([entry]) => {
          this.footerVisible = entry.isIntersecting;
          this.updateVisibility();
        });
        this.footerObserver.observe(footer);
      }
      small.addEventListener('change', () => this.updateVisibility());

      // Mirror price / options / availability from the main form
      this.sync = () => this.syncFromMain();
      this.mutation = new MutationObserver(this.sync);
      this.mutation.observe(this.info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'checked'] });
      this.info.addEventListener('change', () => setTimeout(this.sync, 50));
      this.syncFromMain();

      // Clicking uses the real Add to cart (same validation, drawer, errors)
      this.btn.addEventListener('click', () => {
        if (this.btn.disabled) return;
        this.btn.setAttribute('aria-busy', 'true');
        this.mainButton.click();
        setTimeout(() => this.btn.removeAttribute('aria-busy'), 1200);
      });
    }

    disconnectedCallback() {
      this.buttonObserver && this.buttonObserver.disconnect();
      this.footerObserver && this.footerObserver.disconnect();
      this.mutation && this.mutation.disconnect();
      document.body.classList.remove('clr-has-satc');
    }

    updateVisibility() {
      const show = small.matches && this.aboveButton && !this.footerVisible;
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      this.btn.tabIndex = show ? 0 : -1;
    }

    syncFromMain() {
      const price = this.info.querySelector('.price .price-item--sale, .price .price-item--regular');
      const priceText = price ? price.textContent.trim() : '';
      if (priceText && this.priceEl.textContent !== priceText) this.priceEl.textContent = priceText;

      const options = Array.from(this.info.querySelectorAll('.product-form__input input[type="radio"]:checked')).map((i) => i.value);
      const selects = Array.from(this.info.querySelectorAll('.product-form__input select')).map((s) => s.value);
      const variantText = [...options, ...selects].join(' · ');
      if (variantText && this.variantEl.textContent !== variantText) this.variantEl.textContent = variantText;

      const disabled = this.mainButton.disabled;
      this.btn.disabled = disabled;
      const mainLabel = this.mainButton.querySelector('span');
      const labelText = mainLabel ? mainLabel.textContent.trim() : '';
      if (labelText && this.label.textContent !== labelText) this.label.textContent = labelText;
    }
  }

  customElements.define('clearo-sticky-atc', StickyAtc);
})();
